module.exports = __webpack_public_path__ + "static/media/community.82176215.svg";